export class UploadProgressEvent {
    constructor({ transfer, uploadedBytes, percent, speed, estimatedTime, remainingTime }) {
        this.name = 'progress';
        this.transfer = { ...transfer };
        this.uploadedBytes = uploadedBytes;
        this.percent = percent;
        this.speed = speed;
        this.estimatedTime = estimatedTime;
        this.remainingTime = remainingTime;
    }
    get data() {
        return {
            transfer: this.transfer,
            speed: this.speed,
            estimatedTime: this.estimatedTime,
            remainingTime: this.remainingTime,
            percent: this.percent,
            totalBytes: this.transfer.size,
            uploadedBytes: this.uploadedBytes,
        };
    }
}
